export type Result<T, E> =
  | { ok: true; isError: false; value: T }
  | { ok: false; isError: true; error: E };

export function ok<T, E>(value: T): Result<T, E> {
  return { ok: true, isError: false, value };
}

export function err<T, E>(error: E): Result<T, E> {
  return { ok: false, isError: true, error };
}
